import { AppSignature } from 'src/app/models/app-signature';
import { InstituteModel } from '../../institute/models/institute-model';
import { AddressModel } from 'src/app/models/address.model';
import { UserRolesPermissionMap } from '../../notebook-user-roles/models/notebook-roles';
import { InstituteGroup } from '../../institute-group/models/institute-group-model';
import { FileTransferModel } from 'src/app/models/file-transfer';
import { UserDocuments } from '../../teacher-management/models/teacher-management.model';
import { GradeDivisionSubjectModel } from '../../institute-academic-year/models/institute-academic-year';
import { InstituteGradeSubjectModel } from '../../subject/models/subject-model';


export class StaffModel extends AppSignature {
  salutation: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  profilePicture: string;
  isActive: boolean;
  userNameType: number = 0;
  parentInstituteID: string;
  parentInstituteGroupID: string;
  reportingUserID: string;
  staffID: string;
  isTeachingStaff: boolean;
  businessModelType: number;
  applicationMode: number;
  qualification: string;
}

export class StaffDTO {
  staff: StaffModel = new StaffModel();
  loginRecord: any;
  role: any;
  profileImage: FileTransferModel = new FileTransferModel();
  userDocuments: Array<UserDocuments> = new Array<UserDocuments>();
  institute: InstituteModel = new InstituteModel();
  instituteGroup: InstituteGroup = new InstituteGroup();
  address: AddressModel = new AddressModel();
  username: string = '';
  userRoleIDs: Array<UserRolesPermissionMap> = [];
  subjects: Array<InstituteGradeSubjectModel> = new Array<InstituteGradeSubjectModel>();
}

export class user {
  username: string;
  password: string;
  userID: string;
  isForcedPasswordResetReqiuired: boolean;
}

export class UserData {
  userID: string;
  name: string;
  email: string;
  userType: number;
}

export class StaffPostModel extends StaffDTO {
  user: user = new user();
}

